import moment from "moment";

const cookieName = "promptFeedback";
export const checkIfFeedbackCached = () => {
  return document.cookie.indexOf(cookieName) >= 0;
};

export const cacheFeedback = () => {
  const expires = moment()
    .set({ month: moment().month() + 3 })
    .toDate()
    .toUTCString();
  document.cookie = `${cookieName}=false; expires=${expires};`;
};
